import { createFetch } from "@better-fetch/fetch"

export const $fetch = createFetch({
  baseURL: process.env.REACT_APP_BACKEND,
  auth: {
    type: "Bearer",
    token: () => localStorage.getItem("token") || ""
  }
});
